import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionValidatorService {

  constructor() { }
  public isAlowToChange(permissionGroupName: string, propertyName: string): Boolean{
    let isAllow = true;
    if (permissionGroupName == "FMSI Default Group")
    {
      if (propertyName = "resetAtNextLogon") {
        isAllow = false;
      }
      else if (propertyName="useAuthentication") {
        isAllow = false
      }
      else if (propertyName="loginEnabled") {
        isAllow = false
      }
    }
    return isAllow;
  }
}
